import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Header from '../../../Header';
import styles from './ModalViewHeader.module.css';

const bindClasses = classNameBind.bind(styles);

const ModalViewHeader = ({
  title,
  onClose = undefined,
  dataId,
}) => (
  <div className={bindClasses('header')} data-ppuc-id={dataId}>
    <div className={bindClasses('title', { withCloseButton: Boolean(onClose) })}>
      <Header>
        {title}
      </Header>
    </div>
    {onClose && (
      <button
        type="button"
        className={bindClasses('close-button')}
        onClick={() => { onClose(); }}
        aria-label="close"
      >
        <Icon name="cross" size="medium" />
      </button>
    )}
  </div>
);

ModalViewHeader.displayName = 'ModalView.Header';

export { ModalViewHeader };
